let paymentData = null;
let paymentProcessDataToRetry = null;
let currentRetryAttempt = 0;
let verifonePaymentProcessInterval = null;

$(document).ready(function () {
  let p = $('body').attr('p');
  let posType = $('body').attr('pos_type');

  let holdTimer;
  let isHolding = false;

  passVerifoneDataToWebView({
    action: 'verifone',
    data: {
      action: 'get_device_info',
    },
  });

  // Hold listener on navbar-brand
  $('.navbar-brand')
    .on('mousedown touchstart', function (e) {
      if (!$('body').attr('is_verifone') == 1) {
        return;
      }

      isHolding = true;
      const terminalSerialNumber =
        localStorage.getItem('temrinalUniqueId') || '';

      if (!terminalSerialNumber) {
        showToast({
          type: 'error',
          message:
            'Kunne ikke aktivere frittstående modus. Vennligst prøv å holde inne igjen i tre sekunder.',
        });
        return;
      }

      // Start timing immediately
      const holdStartTime = Date.now();
      clearTimeout(holdTimer);

      // Send request immediately
      $.ajax({
        url: `/api/v1/private/terminal/${terminalSerialNumber.replace(/-/g, '')}`,
        method: 'GET',
        success: function (response) {
          if (response) {
            if (!isHolding) {
              return;
            }

            const elapsed = Date.now() - holdStartTime;
            const openModalIfStillHolding = function () {
              if (!isHolding) {
                return;
              }

              if ($('#terminalModal').length === 0) {
                const modalHTML = `
                  <div class="modal" id="terminalModal" tabindex="-1" aria-labelledby="terminalModalLabel" aria-hidden="true">
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="terminalModalLabel">Skriv inn terminalnavn</h5>
                        </div>
                        <div class="modal-body">
                          <div class="mb-3">
                            <label for="terminalNameInput" class="form-label">Terminalnavn</label>
                            <input type="text" class="form-control" id="terminalNameInput" placeholder="Skriv inn terminalnavn" autocomplete="off">
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Avbryt</button>
                          <button type="button" class="btn btn-primary" id="proceedBtn">Fortsette</button>
                        </div>
                      </div>
                    </div>
                  </div>
                `;
                $('body').append(modalHTML);
              }

              $('#terminalModal').modal('show');
              $('#terminalModal').on('shown.bs.modal', function () {
                $('#terminalNameInput').focus();
              });
            };

            if (elapsed >= 2500) {
              openModalIfStillHolding();
            } else {
              const remaining = 2500 - elapsed;
              clearTimeout(holdTimer);
              if (response.success && response.organizer_id) {
                if (
                  $('form.organizer-form').length &&
                  $('form.organizer-form').hasClass('has-changed')
                ) {
                  $(window).off('beforeunload');
                }
                setTimeout(() => {
                  document.location.href = `/organizer/${response.organizer_id}/payment-standby-mode/${terminalSerialNumber.replace(/-/g, '')}`;
                }, remaining);
                return;
              } else if (!response.success && !response.message) {
                holdTimer = setTimeout(openModalIfStillHolding, remaining);
              } else {
                showToast({
                  type: 'error',
                  message:
                    'Kunne ikke aktivere frittstående modus. Vennligst prøv å holde inne igjen i tre sekunder.',
                });
              }
            }
          }
        },
        error: function (data) {
          if (
            data.responseJSON &&
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        },
      });
    })
    .on('mouseup mouseleave touchend touchcancel', function () {
      isHolding = false;
      clearTimeout(holdTimer);
    });

  $(document).on('click', '#standby-mode-link', function (e) {
    e.preventDefault();
    const temrinalUniqueId = localStorage.getItem('temrinalUniqueId') || '';
    if (temrinalUniqueId) {
      const modalHTML = `
        <div class="modal" id="terminalModal" tabindex="-1" aria-labelledby="terminalModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="terminalModalLabel">Skriv inn terminalnavn</h5>
              </div>
              <div class="modal-body">
                <div class="mb-3">
                  <label for="terminalNameInput" class="form-label">Terminalnavn</label>
                  <input type="text" class="form-control" id="terminalNameInput" placeholder="Skriv inn terminalnavn" autocomplete="off">
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Avbryt</button>
                <button type="button" class="btn btn-primary" id="proceedBtn">Fortsette</button>
              </div>
            </div>
          </div>
        </div>
      `;
      $('#terminalModal').remove();
      $('body').append(modalHTML);

      $.ajax({
        url: `/api/v1/private/terminal/${temrinalUniqueId.replace(/-/g, '')}`,
        method: 'GET',
        success: function (response) {
          if (response) {
            if (response.success && response.organizer_id) {
              if (
                $('form.organizer-form').length &&
                $('form.organizer-form').hasClass('has-changed')
              ) {
                $(window).off('beforeunload');
              }
              document.location.href = `/organizer/${response.organizer_id}/payment-standby-mode/${temrinalUniqueId.replace(/-/g, '')}`;
              return;
            } else {
              $('#terminalModal').modal('show');
              $('#terminalModal').on('shown.bs.modal', function () {
                $('#terminalNameInput').focus();
              });
            }
          }
        },
        error: function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
          showToast({
            type: 'error',
            message:
              'Kunne ikke aktivere frittstående modus. Vennligst prøv å holde inne igjen i tre sekunder.',
          });
        },
      });
    } else {
      showToast({
        type: 'error',
        message:
          'Kunne ikke aktivere frittstående modus. Vennligst prøv å holde inne igjen i tre sekunder.',
      });
    }
  });

  // Handle proceed button click
  $(document).on('click', '#proceedBtn', function () {
    const terminalName = $('#terminalNameInput').val().trim();

    if (terminalName === '') {
      showToast({
        type: 'error',
        message: 'Vennligst skriv inn et gyldig terminalnavn.',
      });
      return;
    }

    const formData = new FormData();
    formData.append('terminal_number', terminalName);
    formData.append('type', $('body').attr('is_pax') == 1 ? 3 : 2);
    formData.append(
      'terminal_id',
      $('.navbar-brand')
        .attr('data-terminal-serial-number')
        .replace(/-/g, '') || ''
    );

    $('#proceedBtn').prop('disabled', true);
    $('#proceedBtn').html('<div class="loader"></div>');

    $.ajax({
      type: 'POST',
      url: '/api/v1/private/terminal/new',
      data: formData,
      enctype: 'multipart/form-data',
      async: true,
      cache: false,
      processData: false,
      contentType: false,
    })
      .done(function (data) {
        if (
          data.message !== undefined &&
          data.message !== null &&
          data.organizer_id !== undefined &&
          data.organizer_id !== null
        ) {
          if (
            $('form.organizer-form').length &&
            $('form.organizer-form').hasClass('has-changed')
          ) {
            $(window).off('beforeunload');
          }
          document.location.href = `/organizer/${data.organizer_id}/payment-standby-mode/${data.terminal_id}`;
        }
      })
      .fail(function (data) {
        if (
          data.responseJSON.redirect_url !== undefined &&
          data.responseJSON.redirect_url !== null
        ) {
          document.location.href = data.responseJSON.redirect_url;
        }

        if (
          data.responseJSON.error_message !== undefined &&
          data.responseJSON.error_message !== null
        ) {
          showToast({
            type: 'error',
            message: data.responseJSON.error_message,
          });
        }
      })
      .always(function () {
        $('#proceedBtn').prop('disabled', false);
        $('#proceedBtn').html('Fortsette');
      });
  });

  $(document).on('keypress', '#terminalNameInput', function (e) {
    if (e.which === 13) {
      $('#proceedBtn').click();
    }
  });

  if (p === 'events' && !!posType) {
    $(document).on('click', '#retryPaymentButton', function () {
      if (
        isOnDevice &&
        (!$('body').attr('is-verifone-session-started') ||
          $('body').attr('is-verifone-session-started') == '0') &&
        locationCart.payment_method === 'payment_verifone_terminal' &&
        (locationCart.terminal_id == undefined ||
          locationCart.terminal_id == '')
      ) {
        checkVerifoneSDKState();
        return;
      }

      $('#retryPaymentButton').addClass('d-none');
      $('#paymentProcessSpinner').removeClass('d-none');
      $('#paymentProcessError').addClass('d-none');
      const processingMessage =
        $('#paymentStatus').data('processing-message') ||
        'Processing Payment...';
      $('#paymentStatus').text(processingMessage);
      $('#cancelPaymentButton')
        .prop('disabled', true)
        .html('<div class="loader"></div>');
      if (paymentProcessDataToRetry) {
        localStorage.setItem(
          'verifone_payment_data',
          JSON.stringify(paymentProcessDataToRetry)
        );

        passVerifoneDataToWebView(paymentProcessDataToRetry);
      }
    });

    $(document).on(
      'click',
      '#cancelPaymentButton, #closePaymentModal',
      function () {
        $('.order-button').each(function () {
          if (
            $(this).is('[data-toggle]') &&
            ($(this).data('payment-method') === 'nets_card' ||
              $(this).data('payment-method') === 'nets_vipps')
          ) {
            $(this).prop('disabled', true);
          } else if ($(this).data('payment-method') === 'payment_terminal') {
            const terminalId = $(this).data('terminal-id');
            if ($(`#${terminalId}.processing`).length) {
              $(this).prop('disabled', true);
            } else {
              $(this).prop('disabled', false);
            }
          } else {
            $(this).prop('disabled', false);
          }
        });
      }
    );
  }

  $(document).on('click', '#close-external-payment-process-modal', function () {
    $('.checkout-action').each(function () {
      const orderCards = $('.order-card').not('.clone');

      if (orderCards.length) {
        const orderCardIds = orderCards
          .map(function () {
            return $(this).attr('id');
          })
          .get();

        if (orderCardIds.includes($(this).attr('data-terminal-id'))) {
          $(this).prop('disabled', true);
          $(this).attr('title', 'Vennligst vent, det pågår en betaling');
        } else {
          $(this).prop('disabled', false);
          $(this).removeAttr('title');
        }
      } else {
        $(this).prop('disabled', false);
        $(this).removeAttr('title');
      }
    });

    $('.quick-order-button').each(function () {
      const orderCards = $('.order-card').not('.clone');

      if (orderCards.length) {
        const orderCardIds = orderCards
          .map(function () {
            return $(this).attr('id');
          })
          .get();

        if (orderCardIds.includes($(this).attr('data-terminal-id'))) {
          $(this).prop('disabled', true);
          $(this).attr('title', 'Vennligst vent, det pågår en betaling');
        } else if (locationCart.products.length > 0) {
          $(this).prop('disabled', false);
          $(this).removeAttr('title');
        }
      } else if (locationCart.products.length > 0) {
        if ($(this).attr('data-terminal-type') != '2') {
          $(this).prop('disabled', false);
        } else {
          $(this).prop('disabled', true);
        }
        $(this).removeAttr('title');
      }
    });
  });
});

function passVerifoneDataToWebView(data) {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
  }
}

function checkTerminalAvailability(checkFor = 'payment') {
  const localDeviceId = localStorage.getItem('deviceID');
  if (checkFor === 'payment') {
    $(".order-button[data-terminal-type='2']").each(function () {
      const button = $(this);
      const terminalId = button.data('terminal-id');

      // Initially disable the button while checking
      button.prop('disabled', true);

      // Send the check
      sendWhenReady(
        window.globalSocket,
        JSON.stringify({
          type: 'verifone',
          action: 'check_availability',
          temrinalUniqueId: terminalId,
          senderDeviceId: localDeviceId,
        })
      ).catch((err) => console.error('Failed to send verifone message:', err));
    });

    if ($('#payment-split-modal').hasClass('show')) {
      sendWhenReady(
        window.globalSocket,
        JSON.stringify({
          type: 'verifone',
          action: 'check_availability',
          temrinalUniqueId: $('#payment-split-button').attr('data-terminal-id'),
          senderDeviceId: localStorage.getItem('deviceID'),
        })
      );
    }
  } else if (checkFor === 'print') {
    $(".print-btn[data-printer-type='VERIFONE']").each(function () {
      const button = $(this);
      const terminalId = button.data('printer-ip');

      // Initially disable the button while checking
      button.prop('disabled', true);

      // Send the check
      sendWhenReady(
        window.globalSocket,
        JSON.stringify({
          type: 'verifone',
          action: 'check_availability',
          temrinalUniqueId: terminalId,
          senderDeviceId: localDeviceId,
        })
      ).catch((err) => console.error('Failed to send verifone message:', err));
    });
  } else if (checkFor === 'return_order') {
    if (
      $('#return-order-modal').hasClass('show') ||
      $('#cancel-last-order-confirm-model').hasClass('show')
    ) {
      $('#return_with_cash').prop('checked', true);
      $('#return_with_payment_original').prop('disabled', true);

      const terminalId =
        $('#return-order-modal').data('terminal-id') ??
        $('#cancel-last-order-confirm-model').data('terminal-id');

      // Send the check
      sendWhenReady(
        window.globalSocket,
        JSON.stringify({
          type: 'verifone',
          action: 'check_availability',
          temrinalUniqueId: terminalId,
          senderDeviceId: localDeviceId,
        })
      ).catch((err) => console.error('Failed to send verifone message:', err));
    }
  }
}
